export const props = {
  slug: {
    type: String,
    required: true
  }
  // clubId: {
  //   type: String,
  //   required: true
  // },
  // name: {
  //   type: String,
  //   default: () => undefined
  // },
  // sort: {
  //   type: String,
  //   default: () => undefined
  // },
  // page: {
  //   type: Number,
  //   default: () => undefined
  // }
}
